export default "__VITE_ASSET__CfL73BTZ__"